module.exports = __webpack_public_path__ + "img/DE01397.2738af11.png";